import React from "react";
import type { ModalHandle } from "src/components/common/Modal/Modal";

const ModalContext = React.createContext<ModalHandle | undefined>(undefined);

export default ModalContext;
